import { Injector } from "@angular/core";
import { AuthService } from "../../../../service/auth-service/auth-service.service";
import { ListView } from "../../../Data/ListView";
import { Art57Node } from "../Art57Node";
import { Art57NodeList } from "../Art57NodeList";
import { TreeNodeMedicinalProductType } from "../Entity/TreeNodeMedicinalProductType";
import { ErrorType } from "../../ErrorType";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeMedicinalProductTypeList extends Art57NodeList {
  constructor(injector: Injector, parent: Art57Node) {
    super(
      injector,
      new ListView(),
      'Medicinal Product Types ({param})'
    );
    this.labelNodeName = 'Medicinal Product Types';
    this.parent = parent;
  }

  override refreshLabel(): void {
    this.label = this.labelTemplate.replace(
      '{param}',
      this.getLabelParamFromChildren()
    );
  }

  override createChildTemplate(): Art57Node[] | null {
    let node = new TreeNodeMedicinalProductType(this.ioc!, this);
    this.children?.push(node);
    this.refreshLabel();
    return [node];
  }

  override getMessage(): any {
    let medicinalproducttypes: any[] = [];
    this.children?.forEach((node) => {
      let medicinalproducttype = node as TreeNodeMedicinalProductType;
      let art57Message = medicinalproducttype.getMessage();
      if (art57Message != null) {
        medicinalproducttypes.push(art57Message);
      }
    });

    if (this.children!.length > 0) {
      return {
        medicinalproducttypes: { medicinalproducttype: medicinalproducttypes },
      };
    } else {
      return;
    }
  }

  override getHeaders(): string[] {
    return ['Code', 'Medicinal Product Type'];
  }

  override validateBusinessRules(): any[] {
    let errors: any = [];
    if ((!this.ioc!.get(AuthService).isEMAOrganisation()) &&
      (!this.children || this.children.length == 0)) {
      errors.push({
        node: this,
        errorID: this.key,
        errorType: ErrorType.bussinessValidationError,
        controlId: undefined,
        controlLabel: '',
        error: 'Section is Mandatory',
      });
    } else {
      errors.push({
        node: this,
        errorID: this.key,
        errorType: ErrorType.errorInactive,
        controlId: undefined,
        controlLabel: '',
        error: '',
      });
    }

    return errors;
  }

  override cloneNode(newParent: Art57Node): Art57Node|undefined {
    let clonedNode: TreeNodeMedicinalProductTypeList =
      new TreeNodeMedicinalProductTypeList(this.ioc!, newParent);

    this.children?.forEach((child) => {
      let childToClone = child as Art57Node;
      let clonedChildren = childToClone.cloneNode(clonedNode);
      if (clonedChildren) {
          clonedNode.children?.push(clonedChildren);
          clonedChildren.refreshLabel();
      }
    });

      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)


    return clonedNode;
  }
}

